import { jsx as o } from "react/jsx-runtime";
import { C as s } from "./Core-DVnHiJm2.mjs";
const m = ({ children: r }) => /* @__PURE__ */ o(s, { brand: "rtv", children: r });
export {
  m as R
};
